import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import {authorizeWarning} from './authorizeWarning/authorizeWarning';
import {checkout} from './checkout/checkout';
import {completeOrder} from './completeOrder/completeOrder';
import {currentStep} from './currentStep/currentStep';
import {deliveryStep} from './deliveryStep';
import {editStep} from './editStep/editStep';
import {newsletterSubscription} from './newsletterSubscription/newsletterSubscription';
import {orderReviewItems} from './orderReviewItems/orderReviewItems';
import {orderReviewTotals} from './orderReviewTotals/orderReviewTotals';
import {paymentStep} from './paymentStep';
import {primer} from './primer/primer';
import {shippingRegion} from './shippingRegion/shippingRegion';
import {showCaliforniaPrepositionPopup} from './showCaliforniaPrepositionPopup/showCaliforniaPrepositionPopup';
import {status} from './status/status';

export const checkoutSideReview = combineReducers({
    authorizeWarning,
    checkout,
    completeOrder,
    currentStep,
    deliveryStep: persistReducer(
        {blacklist: [], key: 'checkoutPersistentStore', storage},
        deliveryStep,
    ),
    editStep,
    newsletterSubscription,
    orderReviewItems,
    orderReviewTotals,
    paymentStep,
    primer,
    shippingRegion,
    showCaliforniaPrepositionPopup,
    status,
});
